<template>
  <div>
    <b-form-group
      label="Paket"
      label-for="id_project_packages"
    >
      <validation-provider
        #default="{ errors }"
        name="Paket"
        rules="required"
      >
        <v-select
          id="id_project_packages"
          v-model="dataItem.id_project_packages"
          label="title"
          :options="packages"
          :reduce="item => item.id"
          placeholder="Seçiniz"
          :disabled="!dataItem.id_projects"
          :clearable="false"
          @input="showAlert"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-alert
      v-if="alertStatus"
      variant="info"
      show
    >
      <div class="alert-body">
        <FeatherIcon icon="InfoIcon" />
        Proje paketinde alt pakete geçmek için yeni lisans oluşturun.
      </div>
    </b-alert>
  </div>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BAlert,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'LicenceProjectPackage',
  components: {
    BFormGroup,
    vSelect,
    BAlert,
    ValidationProvider,
  },
  data() {
    return {
      alertStatus: false,
      required,
      locale: 'tr',
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['licenses/dataItem']
    },
    packages() {
      let response = []
      const data = this.$store.getters['projectPackages/dataList']
      if (this.dataItem.id) {
        data.forEach(item => {
          if (item.id >= this.dataItem.id_project_packages) {
            response.push(item)
          }
        })
      } else {
        response = data
      }
      return response
    },
  },
  created() {
    localize(this.locale)
  },
  methods: {
    showAlert() {
      if (this.dataItem.id) {
        this.alertStatus = true
      }
    },
  },
}
</script>
